(function () {
  var MESSAGE =
    "Free gifts cannot be ordered on their own. Please add a product to continue.";
  var lastCart = null;
  var inflight = null;

  function isGiftItem(item) {
    if (!item) return false;
    if (item.final_line_price === 0 || item.original_line_price === 0) return true;
    if (item.final_price === 0 || item.price === 0) return true;
    var title = String(item.product_title || item.title || "");
    if (title.indexOf("🎁") === 0) return true;
    var props = item.properties || {};
    return Object.keys(props).some(function (key) {
      var val = String(props[key] || "");
      return /gift|freebie|gbb|easybundle|_eb_/i.test(key) || /gift|freebie/i.test(val);
    });
  }

  function isFreebieOnlyCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.total_price === 0;
  }

  function getCart() {
    if (inflight) return inflight;
    inflight = fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        lastCart = cart;
        inflight = null;
        return cart;
      })
      .catch(function () {
        inflight = null;
        return lastCart;
      });
    return inflight;
  }

  function checkoutIntent(target) {
    if (!target || !target.closest) return false;
    if (target.closest('a[href*="/checkout"], a[href*="/checkouts"]')) return true;
    if (target.closest('button[name="checkout"], input[name="checkout"]')) return true;
    if (target.closest(".gokwik-checkout button, #gokwik-buy-now")) return true;
    var clickable = target.closest("button, a, [role='button']");
    if (!clickable) return false;
    var text = (clickable.textContent || "").replace(/\s+/g, " ").trim();
    return /checkout/i.test(text);
  }

  function deny(e) {
    if (e.preventDefault) e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.alert(MESSAGE);
  }

  function allowCachedPaidCart() {
    return lastCart && lastCart.items && lastCart.items.length && lastCart.total_price > 0;
  }

  document.addEventListener(
    "click",
    function (e) {
      if (window.__lumineveAllowCheckout) return;
      if (!checkoutIntent(e.target)) return;
      if (allowCachedPaidCart()) return;
      if (lastCart && isFreebieOnlyCart(lastCart)) {
        deny(e);
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      getCart().then(function (cart) {
        if (isFreebieOnlyCart(cart)) {
          window.alert(MESSAGE);
          return;
        }
        var el = e.target.closest("button, a, input");
        window.__lumineveAllowCheckout = true;
        if (el && el.closest(".gokwik-checkout, #gokwik-buy-now") && typeof window.onCheckoutClick === "function") {
          window.onCheckoutClick(el.closest("button") || el);
        } else if (el) {
          el.click();
        }
        setTimeout(function () {
          window.__lumineveAllowCheckout = false;
        }, 800);
      });
    },
    true
  );

  document.addEventListener(
    "submit",
    function (e) {
      if (window.__lumineveAllowCheckout) return;
      var form = e.target;
      if (!form || form.method && form.method.toLowerCase() !== "post") return;
      var hasCheckout =
        (e.submitter && e.submitter.name === "checkout") ||
        (form.querySelector && form.querySelector('[name="checkout"]'));
      if (!hasCheckout) return;
      if (allowCachedPaidCart()) return;
      e.preventDefault();
      e.stopPropagation();
      getCart().then(function (cart) {
        if (isFreebieOnlyCart(cart)) {
          window.alert(MESSAGE);
          return;
        }
        window.__lumineveAllowCheckout = true;
        if (typeof form.requestSubmit === "function") form.requestSubmit(e.submitter || undefined);
        else form.submit();
        setTimeout(function () {
          window.__lumineveAllowCheckout = false;
        }, 800);
      });
    },
    true
  );

  function wrapGokwik() {
    if (typeof window.onCheckoutClick !== "function" || window.onCheckoutClick.__lumineveWrapped) return;
    var original = window.onCheckoutClick;
    window.onCheckoutClick = function (btn) {
      if (window.__lumineveAllowCheckout) return original.apply(this, arguments);
      if (allowCachedPaidCart()) return original.apply(this, arguments);
      return getCart().then(function (cart) {
        if (isFreebieOnlyCart(cart)) {
          window.alert(MESSAGE);
          return;
        }
        window.__lumineveAllowCheckout = true;
        var result = original.apply(window, [btn]);
        setTimeout(function () {
          window.__lumineveAllowCheckout = false;
        }, 800);
        return result;
      });
    };
    window.onCheckoutClick.__lumineveWrapped = true;
  }

  wrapGokwik();
  window.addEventListener("gokwikLoaded", wrapGokwik);
  document.addEventListener("DOMContentLoaded", function () {
    wrapGokwik();
    getCart();
  });
})();
